<!-- sidebar.component.html -->
<aside class="sidebar" [class.collapsed]="!expanded()" role="navigation" aria-label="Main">
    <div class="head">

        <div class="brand">
            <div class="brand-logo" (click)="toggleSidebar()">
                <img *ngIf="logoSrc()" [src]="logoSrc()" alt="Logo" class="brand-logo-img" />
            </div>
            @if (expanded()) {
            <div class="brand-info">
                <div class="name" [title]="currentCenter()?.name || ''">{{ currentCenter()?.name || 'HCAH' }}</div>
                <div class="role">{{ userRole() || 'User' }}</div>
            </div>
            <div class="brand-dropdown">
                <button type="button"
                    class="center-dropdown-button"
                    (click)="toggleCenterDropdown($event, centerPopover)"
                    [attr.aria-expanded]="centerDropdownOpen()"
                    aria-label="Select center">
                    <svg class="center-dropdown-caret" [class.rotated]="centerDropdownOpen()"
                        width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true">
                        <path d="M0 0L5 5L10 0H0Z" fill="#64758B"/>
                    </svg>
                </button>
                <p-popover #centerPopover styleClass="center-switcher-popover"
                    (onShow)="onCenterPopoverShow()"
                    (onHide)="onCenterPopoverHide()">
                    <div class="center-dropdown">
                        <div class="center-search">
                            <i class="pi pi-search center-search-icon"></i>
                            <input #centerSearchInput
                                class="center-search-input"
                                type="search"
                                placeholder="Search centers"
                                aria-label="Search centers"
                                [value]="centerQuery()"
                                (input)="centerQuery.set(($any($event.target)).value)" />
                        </div>
                        @if (loadingCenters()) {
                        <div class="center-dropdown-loading">
                            <i class="pi pi-spin pi-spinner"></i>
                            <span>Loading centers...</span>
                        </div>
                        } @else {
                        <div class="center-dropdown-list">
                            @for (center of filteredCenters(); track center.id) {
                            <button
                                type="button"
                                class="center-dropdown-item"
                                [class.active]="isCurrentCenter(center)"
                                [disabled]="switchingCenter()"
                                (click)="onCenterSelect(center)">
                                <span class="center-name">{{ center.name }}</span>
                                @if (isCurrentCenter(center)) {
                                <i class="pi pi-check"></i>
                                }
                            </button>
                            } @empty {
                            <div class="center-dropdown-empty">No centers found</div>
                            }
                        </div>
                        }
                    </div>
                </p-popover>
            </div>
            }
        </div>

        @if (expanded()) {
        <div class="toggle-wrapper">
            <button type="button"
                class="sidebar-toggle-btn"
                (click)="toggleSidebar()"
                [attr.aria-expanded]="expanded()"
                aria-label="Toggle sidebar">
                <svg class="icon-toggle" [class.flip]="!expanded()" width="18" height="16" viewBox="0 0 18 16" fill="none"
                    aria-hidden="true">
                    <path
                        d="M7 1.2V14.8M3.4 4H4.6M3.4 7.2H4.6M1 8c0-3 0-4.5.764-5.551.247-.339.545-.638.884-.885C3.7.8 5.201.8 8.2.8h1.6c3 0 4.5 0 5.551.764.339.247.638.545.885.885C17 3.5 17 5.001 17 8c0 3-.0 4.5-.764 5.551-.247.339-.545.638-.885.885C14.3 15.2 12.799 15.2 9.8 15.2H8.2C5.2 15.2 3.7 15.2 2.649 14.436a3.9 3.9 0 0 1-.885-.885C1 12.5 1 11 1 8Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M13 6.4l-0.9808 0.8456C11.6064 7.6015 11.4 7.7791 11.4 8c0 0.2208 0.2064 0.3984 0.6192 0.7544L13 9.6"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        }
    </div>

    @if (expanded()) {
        <div class="search">
            <i class="pi pi-search s-icon"></i>
            <input #searchInput class="s-input" type="search" (input)="query.set(($any($event.target)).value)" placeholder="Search" [value]="query()"/>
        </div>
    }

    <nav class="menu">
        @for (item of filtered(); track item.key) {
        <div class="group" [class.has-children]="!!item.children">
            <div class="item-wrapper">
                @if (item.children) {
                <button class="item" type="button"
                    [class.active]="isItemActive(item)"
                    (click)="handleItemClick(item, $event)"
                    [attr.aria-expanded]="openKey() === item.key"
                    [attr.aria-controls]="idFor(item.key)"
                    [title]="!expanded() ? item.label : null">
                    <span class="icon" aria-hidden="true">
                        <ui-icon [name]="item.icon"></ui-icon>
                    </span>
                    @if (expanded()) {
                    <span class="label">{{ item.label }}</span>
                    <span class="chev" [class.rot]="openKey() === item.key">
                        <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M0.154081 0.15296C0.252768 0.0550197 0.3866 0 0.526144 0C0.665688 0 0.79952 0.0550197 0.898207 0.15296L3.50318 2.73897L6.10815 0.15296C6.2074 0.0577953 6.34033 0.0051374 6.47832 0.00632771C6.6163 0.00751802 6.74829 0.0624612 6.84586 0.159323C6.94344 0.256186 6.99878 0.387217 6.99998 0.524195C7.00118 0.661174 6.94814 0.79314 6.85227 0.891671L3.87524 3.84704C3.77655 3.94498 3.64272 4 3.50318 4C3.36363 4 3.2298 3.94498 3.13111 3.84704L0.154081 0.891671C0.0554229 0.793701 0 0.660844 0 0.522315C0 0.383786 0.0554229 0.250929 0.154081 0.15296Z" fill="#475569"/>
                        </svg>
                    </span>
                    }
                </button>
                } @else {
                <button class="item" type="button"
                    [routerLink]="item.route || null"
                    [attr.aria-expanded]="null"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [title]="!expanded() ? item.label : null">
                    <span class="icon" aria-hidden="true">
                        <ui-icon [name]="item.icon"></ui-icon>
                    </span>
                    @if (expanded()) {
                    <span class="label">{{ item.label }}</span>
                    }
                </button>
                }
            </div>

            @if (item.children) {
            <div class="submenu" [id]="idFor(item.key)" [class.open]="openKey() === item.key">
                @for (sub of item.children; track sub.label) {
                <div class="subitem-wrapper" [class.has-children]="!!sub.children">
                    @if (sub.children) {
                    <button type="button" class="subitem subitem-button" 
                        (click)="toggleSubGroup(subIdFor(item.key, sub.label))"
                        [attr.aria-expanded]="isSubOpen(subIdFor(item.key, sub.label))">
                        <span class="marker" aria-hidden="true"></span>
                        <span class="slabel">{{ sub.label }}</span>
                        <span class="chev chev-sub" [class.rot]="isSubOpen(subIdFor(item.key, sub.label))">
                            <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M0.154081 0.15296C0.252768 0.0550197 0.3866 0 0.526144 0C0.665688 0 0.79952 0.0550197 0.898207 0.15296L3.50318 2.73897L6.10815 0.15296C6.2074 0.0577953 6.34033 0.0051374 6.47832 0.00632771C6.6163 0.00751802 6.74829 0.0624612 6.84586 0.159323C6.94344 0.256186 6.99878 0.387217 6.99998 0.524195C7.00118 0.661174 6.94814 0.79314 6.85227 0.891671L3.87524 3.84704C3.77655 3.94498 3.64272 4 3.50318 4C3.36363 4 3.2298 3.94498 3.13111 3.84704L0.154081 0.891671C0.0554229 0.793701 0 0.660844 0 0.522315C0 0.383786 0.0554229 0.250929 0.154081 0.15296Z" fill="#475569"/>
                            </svg>
                        </span>
                    </button>
                    <div class="subsubmenu" [id]="subIdFor(item.key, sub.label)" 
                        [class.open]="isSubOpen(subIdFor(item.key, sub.label))">
                        @for (subsub of sub.children; track subsub.label) {
                        <a class="subsubitem" [routerLink]="subsub.route" routerLinkActive="sub-active" [routerLinkActiveOptions]="{ exact: true }">
                            <span class="marker" aria-hidden="true"></span>
                            <span class="slabel">{{ subsub.label }}</span>
                        </a>
                        }
                    </div>
                    } @else {
                    <a class="subitem" [routerLink]="sub.route" routerLinkActive="sub-active" [routerLinkActiveOptions]="{ exact: true }">
                        <span class="marker" aria-hidden="true"></span>
                        <span class="slabel">{{ sub.label }}</span>
                    </a>
                    }
                </div>
                }
            </div>
            }
        </div>
        }
    </nav>
</aside>